module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "content-1"
  }, [_c('div', {
    staticClass: "gu-duan"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择加油站"
    },
    model: {
      value: (_vm.oilStation),
      callback: function($$v) {
        _vm.oilStation = $$v
      },
      expression: "oilStation"
    }
  }, _vm._l((_vm.oilStations), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "content-1-tables"
  }, [_c('div', {
    staticClass: "content-1-table-1 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": "进销存数据"
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.showData), function(data, index) {
    return _c('tr', _vm._l((data.slice(0, 8)), function(value) {
      return (value.rowspan !== 0) ? _c('td', {
        class: {
          'data-td': !value.label, 's-bak-td': !value.label && (index % 3 === 1)
        },
        attrs: {
          "rowspan": value.rowspan || 1
        }
      }, [_vm._v(_vm._s(value.label || value))]) : _vm._e()
    }))
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-1-table-2 mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": "预测结果"
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.showData), function(data, index) {
    return _c('tr', _vm._l((data.slice(8)), function(value) {
      return (value.rowspan !== 0) ? _c('td', {
        class: {
          's-bak-td': !value.label && (index % 3 === 1)
        }
      }, [_vm._v(_vm._s(value.label || value))]) : _vm._e()
    }))
  }))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "content-2-table mii-table"
  }, [_c('content-title', {
    attrs: {
      "title": '每日订单（' + _vm.day + '）'
    }
  }), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "background": "#fff"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.preDayData.slice(_vm.start_index, _vm.start_index + 10)), function(data, index) {
    return _c('tr', _vm._l((data.slice(1)), function(value) {
      return (value.rowspan !== 0) ? _c('td', {
        class: {
          'jj-bak-td': value === '紧急订单', 'ps-bak-td': value === '可配送订单'
        },
        attrs: {
          "rowspan": value.rowspan || 1
        }
      }, [_vm._v(_vm._s(value.label || value))]) : _vm._e()
    }))
  }))]), _vm._v(" "), _c('div', {
    staticClass: "content-2-page"
  }, [_c('el-pagination', {
    attrs: {
      "small": "",
      "layout": "prev, pager, next",
      "page-size": _vm.row_num,
      "total": _vm.preDayData.length
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)], 1), _vm._v(" "), (_vm.showNote) ? _c('div', {
    staticClass: "content-2-note"
  }, [_vm._v("\n      日销量预测分析步骤："), _c('br'), _vm._v("\n      1.时间趋势检验：通过线图以及Dickey-Fuller对数据进行检验，如果时间趋势不稳定，则需要对数据进行分解和转换。"), _c('br'), _vm._v("\n      2.自相关，偏相关函数分析，选择匹配时间序列数据的模型 - ARIMA"), _c('br'), _vm._v("\n      3.模型拟合以及检验：用RStudio中tseries已经forecast程序包进行分析，检验和预测。模型检验参数赤池信息法(AIC)，贝叶斯信息法(BIC)数值最终用来判断模型的拟合。"), _c('br'), _vm._v("\n      订单紧急程度划分说明："), _c('br'), _vm._v("\n      1.可配送订单：24小时<断货时间点≤48小时；"), _c('br'), _vm._v("\n      1.紧急订单：断货时间点≤24小时。\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-2-btn"
  }, [_c('div', {
    staticClass: "btn-top-jiao"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.showNote = !_vm.showNote
      }
    }
  }, [_vm._v("预"), _c('br'), _vm._v("测"), _c('br'), _vm._v("分"), _c('br'), _vm._v("析"), _c('br'), _vm._v("方"), _c('br'), _vm._v("法")]), _vm._v(" "), _c('div', {
    staticClass: "btn-bottom-jiao"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.preData) + "\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("店名")]), _vm._v(" "), _c('th', [_vm._v("商品")]), _vm._v(" "), _c('th', [_vm._v("时间")]), _vm._v(" "), _c('th', [_vm._v("期初库存")]), _vm._v(" "), _c('th', [_vm._v("入库量")]), _vm._v(" "), _c('th', [_vm._v("出库量")]), _vm._v(" "), _c('th', [_vm._v("期末库存")]), _vm._v(" "), _c('th', [_vm._v("空容")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("平均销量")]), _vm._v(" "), _c('th', [_vm._v("消耗率")]), _vm._v(" "), _c('th', [_vm._v("断货时间点")]), _vm._v(" "), _c('th', [_vm._v("在途时间(H)")]), _vm._v(" "), _c('th', [_vm._v("订单紧急程度")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("订单类型")]), _vm._v(" "), _c('th', [_vm._v("点名")]), _vm._v(" "), _c('th', [_vm._v("区域")]), _vm._v(" "), _c('th', [_vm._v("商品")]), _vm._v(" "), _c('th', [_vm._v("空容")]), _vm._v(" "), _c('th', [_vm._v("平均销量")]), _vm._v(" "), _c('th', [_vm._v("断货时间点")]), _vm._v(" "), _c('th', [_vm._v("在途时间(H)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f71f24f2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/tobacco/prediction_to.vue
// module id = 1013
// module chunks = 1